import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '91n com 官方入口指南',
  url: 'https://91n-guide.com',
  description: '提供 91n com 最新访问地址、使用教程、常见问题解答及安全访问建议，帮助用户快速找到并正常使用 91n com 相关服务。',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://91n-guide.com/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '91n com 官方入口指南',
  url: 'https://91n-guide.com',
  description: '致力于为广大用户提供 91n com 平台的最新访问入口、使用教程和安全指南。',
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '91n com 官方入口 | 最新地址与使用指南',
  description: '91n com 是用户热搜的网络平台入口，本页提供 91n com 最新访问地址、使用教程、常见问题解答及安全访问建议，帮助用户快速找到并正常使用 91n com 相关服务。',
  url: 'https://91n-guide.com',
  isPartOf: {
    '@type': 'WebSite',
    name: '91n com 官方入口指南',
    url: 'https://91n-guide.com',
  },
};

export default function HomePage() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeatureSection />
        <LatestArticles />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}